export const CENTRAL_QUARTER_PREFIX = 'central_quarter_';
export const FLAG_PREFIX = 'flag_';

export const CITY_COMMON_BUILDING_TOKENS = {
  QUARTER: 'quarter',
  FARM: 'farm',
  BARRACKS: 'barracks',
}
export const COMMON_BUILDING_TOKENS = {
  ...CITY_COMMON_BUILDING_TOKENS,
  ROAD: 'road',
}
export const SPECIAL_BUILDING_TOKENS = {
  PALACE: 'palace',
  WAREHOUSE: 'warehouse',
  MILITARY_CAMP: 'military_camp',
  ARSENAL: 'arsenal',
  TEMPLE: 'temple',
  GUILD: 'guild',
  FORTRESS: 'fortress',
}
export const KEY_POINT_TOKENS = {
  MINE: 'mine',
  SUPER_MINE: 'super_mine',
  RUINS: 'ruins',
  SUPER_RUINS: 'super_ruins',
}
export const TERRAIN_TOKENS = {
  MOUNTAIN: 'mountain',
  SEA: 'sea',
}

export const TOKENS = {
  ...COMMON_BUILDING_TOKENS,
  ...SPECIAL_BUILDING_TOKENS,
  ...KEY_POINT_TOKENS,
  ...TERRAIN_TOKENS,
};
export const CITY_HEX_TOKENS = {
  ...CITY_COMMON_BUILDING_TOKENS,
  ...KEY_POINT_TOKENS,
}
export const CITY_TOKENS = {
  ...CITY_HEX_TOKENS,
  ...SPECIAL_BUILDING_TOKENS,
}
export const UNDESTRUCTIBLE_TOKENS = [
  COMMON_BUILDING_TOKENS.ROAD,
  KEY_POINT_TOKENS.MINE,
  KEY_POINT_TOKENS.SUPER_MINE,
  KEY_POINT_TOKENS.RUINS,
  KEY_POINT_TOKENS.SUPER_RUINS,
  TERRAIN_TOKENS.SEA,
  TERRAIN_TOKENS.MOUNTAIN,
  //TODO: FACTIONS: undestructable tokens
]
// Типы токенов, которые работают только при рабочем смежном квартале
export const TOKENS_RESTRICTED_IN_FIRST_ROUND = [
  TOKENS.ROAD,
];

// Типы токенов, которые работают только при рабочем смежном квартале
export const TOKENS_RELIED_ON_QUARTER = [
  TOKENS.FARM,
  TOKENS.BARRACKS,
  TOKENS.MINE,
  TOKENS.SUPER_MINE,
  TOKENS.RUINS,
  TOKENS.SUPER_RUINS,
];

// Типы токенов, которые нельзя строить смежно кварталу противника
export const TOKENS_RESTRICTED_FOR_BUILDING_NEAR_ENEMY_QUARTERS = [
  TOKENS.FARM,
  TOKENS.BARRACKS,
  TOKENS.QUARTER,
  TOKENS.MINE,
  TOKENS.SUPER_MINE,
  TOKENS.RUINS,
  TOKENS.SUPER_RUINS,
];

export const TOKENS_MILITARY_BUILDINGS = [
  TOKENS.BARRACKS,
  SPECIAL_BUILDING_TOKENS.ARSENAL,
  SPECIAL_BUILDING_TOKENS.MILITARY_CAMP,
];

export const ANY_COMMON_BUILDING_TOKEN = {
  id: 'any_common_building',
  label: 'Обычные строения',
  image: '/img/hexes/common building.2a517969.png',
}
export const ANY_SPECIAL_BUILDING_TOKEN = {
  id: 'any_special_building',
  label: 'Специальные строения',
  image: '/img/hexes/special buildings/special building.c496c562.png',
}

export const TOKEN_NAME_MAPPING = {
  [COMMON_BUILDING_TOKENS.QUARTER]: 'Базовый квартал',
  [COMMON_BUILDING_TOKENS.FARM]: 'Ферма',
  [COMMON_BUILDING_TOKENS.BARRACKS]: 'Казарма',
  [COMMON_BUILDING_TOKENS.ROAD]: 'Дорога',
  [SPECIAL_BUILDING_TOKENS.PALACE]: 'Дворец',
  [SPECIAL_BUILDING_TOKENS.WAREHOUSE]: 'Склад',
  [SPECIAL_BUILDING_TOKENS.MILITARY_CAMP]: 'Лагерь',
  [SPECIAL_BUILDING_TOKENS.ARSENAL]: 'Арсенал',
  [SPECIAL_BUILDING_TOKENS.TEMPLE]: 'Храм',
  [SPECIAL_BUILDING_TOKENS.GUILD]: 'Гильдия',
  [SPECIAL_BUILDING_TOKENS.FORTRESS]: 'Крепость',
  [KEY_POINT_TOKENS.MINE]: 'Рудник',
  [KEY_POINT_TOKENS.SUPER_MINE]: 'Великий рудник',
  [KEY_POINT_TOKENS.RUINS]: 'Руины',
  [KEY_POINT_TOKENS.SUPER_RUINS]: 'Великие руины',
  [TERRAIN_TOKENS.MOUNTAIN]: 'Гора',
  [TERRAIN_TOKENS.SEA]: 'Море',
}